import { Injectable } from '@angular/core';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import {LoginManager} from '../_managers/login-manager.services'

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private loginManager: LoginManager,private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentUser = this.loginManager.currentUserValue;
        const isLoggedIn = currentUser && currentUser.jwt;
        const isApiUrl = request.url.startsWith(environment.baseUrl);
        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.jwt}`
                }
            });
        }

        return next.handle(request).pipe(
          catchError((err: HttpErrorResponse) => {
    
            if (err.status === 401) {
              this.router.navigateByUrl('/login');
            }
    
            return throwError( err );
    
          })
        );
     /*request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.loginManager.getToken()}`
        }
      });*/
  
      //return next.handle(request);
  }
}
